__turbopack_context__.v({
  "bienvenidaContainer": "Step4BienvenidaView-module__mqgTlW__bienvenidaContainer",
  "brandHighlight": "Step4BienvenidaView-module__mqgTlW__brandHighlight",
  "contentWrapper": "Step4BienvenidaView-module__mqgTlW__contentWrapper",
  "ctaButton": "Step4BienvenidaView-module__mqgTlW__ctaButton",
  "exclamationEnd": "Step4BienvenidaView-module__mqgTlW__exclamationEnd",
  "exclamationStart": "Step4BienvenidaView-module__mqgTlW__exclamationStart",
  "logoBadge": "Step4BienvenidaView-module__mqgTlW__logoBadge",
  "subtitle": "Step4BienvenidaView-module__mqgTlW__subtitle",
  "title": "Step4BienvenidaView-module__mqgTlW__title",
});
